import React from 'react'
import'./Header.css'
function Header() {
    return (
        <div className="title">
            <h1>Wheather-APP</h1>
        </div>
    )
}

export default Header
